import { ResizeObserver as PolyfillResizeObserver } from '@juggle/resize-observer'

if (typeof window !== 'undefined' && !('ResizeObserver' in window)) {
  // Polyfill window.ResizeObserver for older browsers
  // @ts-expect-error — Window is not typed to allow adding `ResizeObserver`
  window.ResizeObserver = PolyfillResizeObserver
}
